/* TARE — tare.js */
(function () {
  'use strict';

  // ── Header scroll state ──
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Mobile nav toggle ──
  var toggle = document.getElementById('nav-toggle');
  var nav    = document.getElementById('site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
      if (open) {
        nav.style.cssText = 'display:flex;flex-direction:column;position:absolute;top:100%;left:0;right:0;background:var(--paper);padding:16px 24px;gap:16px;border-bottom:1px solid rgba(26,23,20,0.1);z-index:100';
      } else {
        nav.removeAttribute('style');
      }
    });
  }

  // ── Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Email form feedback ──
  var emailForm = document.getElementById('email-capture-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      var btn = emailForm.querySelector('button[type="submit"]');
      if (btn) {
        setTimeout(function () {
          btn.textContent = 'Done.';
          btn.style.background = 'var(--ink)';
        }, 100);
      }
    });
  }

  // ── Intersection observer for fade-in ──
  if ('IntersectionObserver' in window) {
    var fadeEls = document.querySelectorAll('.science__card, .journal__article, .belief__stat, .product-spec');
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          fadeObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    fadeEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      fadeObs.observe(el);
    });
  }

})();
